import React, { useState } from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { ArrowDownIcon } from '@depop/web-ui-kit/Icons/ArrowDownIcon';
import { ArrowTopIcon } from '@depop/web-ui-kit/Icons/ArrowTopIcon';

import styles from './styles.module.css';

type Props = {
  title: string;
  children: React.ReactNode[];
};

export function FooterAccordian({ title, children }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const IconComponent = isOpen ? ArrowTopIcon : ArrowDownIcon;

  return (
    <>
      <button
        className={styles.footerAccordianButton}
        onClick={() => setIsOpen(!isOpen)}
      >
        <Body variant={isOpen ? 'sm-bold' : 'sm-regular'} as="span">
          {title}
        </Body>
        <IconComponent size={20} />
      </button>
      {isOpen && children}
    </>
  );
}
